import styled from "styled-components";
import { FlexibleDiv } from "../../../../components/flexibleDiv/flexibleDiv.component";

export const HowToValidateContainer = styled(FlexibleDiv)`
  justify-content: space-around;
`;
export const SectionContainer = styled(FlexibleDiv)`
  flex-direction: column;
  align-items: center;
  height: auto;
`;

export const CardSection = styled(FlexibleDiv)`
  justify-content: space-around;
  align-items: center;
  height: auto;
 
`;
export const TitleText = styled.p`
  font-size: 3rem;
  color: #6f859f;
  padding: 0;
  text-align: right;
  @media (max-width: 800px) {
    font-size: 2.7rem;
    text-align: center;
  }
`;
export const ButtonContainer = styled(FlexibleDiv)`
  width: 35%;
  align-items: center;
  justify-content: center;
  height: auto;
  @media (max-width: 800px) {
    width:90%;
  }
`;
export const SubText = styled.h5`
  font-size: 3rem;
  color: #8408fe;
  font-family: segioBold;
  text-align: right;
  @media (max-width: 800px) {
    font-size: 2.7rem;
    text-align: center;
  }
`;
export const Text = styled.p`
  font-size: 1.2rem;
  color: #6f859f;
  margin-bottom: 2rem;
  text-align: right;
  @media (max-width: 800px) {
    text-align: center;
    font-size: 1.1rem;
  }
`;
